export enum AppRoute {
  HOME = '/',
  PREVIEW = '/preview',
  RESULTS = '/results',
  ERROR = '/error',
  EMPTY = '/empty',
}

export enum ConvertorAppRoutesSimple {
  HOME = '/',
  PREVIEW = '/preview',
  EMPTY = '/empty',
}

export default AppRoute;
